import { Button } from '@visikon/spine';
import { Tokens } from '@visikon/spine/src/styles/tokens';
import styled from 'styled-components';
import { NavigationIcon } from '../../images/icons';
import { useIsEmbedded } from '../../reducers/resourcesReducer';
import { useSelfServiceIsEditMode } from '../../screens/embeddedMessageScript/EmbeddedMessageScript';

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent !important;

  svg {
    width: 18px;
    path {
      fill: none;
    }
  }
`;

type Props = {
  direction: 'up' | 'down';
  currentIndex: number;
  contentType: string;
};

export const MoveButton = (p: Props) => {
  const onClick = () => {
    window.parent.postMessage({ type: p.contentType, action: `move-${p.direction}`, currentIndex: p.currentIndex }, '*');
  };

  const isEmbedded = useIsEmbedded();
  const isEditMode = useSelfServiceIsEditMode();

  if (!isEmbedded || !isEditMode) return null;

  return (
    <Button
      onClick={onClick}
      size={'small'}
      variant={'ghost'}
      style={{
        textTransform: 'none',
        background: 'rgba(0, 109, 179, 0.06)',
        fontWeight: Tokens.text.weight.bold,
        padding: '10px',
      }}
    >
      <IconWrapper>
        <NavigationIcon name={`arrow_${p.direction}`} active={true} />
      </IconWrapper>
    </Button>
  );
};
